import React, { useEffect, useState } from "react";
import { getNews } from "../Service/Api";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Slider from "react-slick";

const News = () => {
  const [circularData, setCircularData] = useState([]);
  const [openModel, setOpenmodal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const cirData1 = await getNews();
        const cirData = cirData1.filter(
          (item) =>
            item.category === "News" || item.category === "Both Sections",
        );
        cirData.sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));
        setCircularData(cirData || []);
      } catch (error) {
        console.error("Failed to fetch news:", error);
        setCircularData([]);
      }
    };
    fetchData();
  }, []);
  const modalPopup = (item) => {
    setSelectedItem(item); // Set the clicked item's data
    setOpenmodal(true); // Open the modal
  };

  const handleClose = () => {
    setOpenmodal(false);
    setSelectedItem(null); // Clear the selected item
  };
  const emptyArray = [{}];
  const newsToShow = circularData.length > 0 ? circularData : emptyArray;
  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: newsToShow.length > 1,
    autoplay: newsToShow.length > 1,
    speed: 600,
    autoplaySpeed: 1800,
    cssEase: "ease-in-out",
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    pauseOnHover: true,
    swipeToSlide: true,
  };

  return (
    <>
      <div className="newsbg">
        <div className="mainstitle">
          <h2> Circulars </h2>
          <Link to="/News">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/arrow.png"
              className="img-fluid"
            />
          </Link>
        </div>
        <div className="news-scroll-container">
          <ul className="newsboxlist">
            {/* <li>
              <div className="newsbox">
                <div className="newsdesc">
                  <p> School Level Fee Regulation Committee</p>
                </div>

                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SLFRC.pdf"
                  target="_blank"
                >
                  <i className="bi bi-paperclip"></i>
                </Link>
              </div>
            </li> */}
            <Slider key={`news-slider-${newsToShow.length}`} {...sliderSettings}>
              {newsToShow.map((item, index) => (
                <li key={index}>
                  <div className="newsbox">
                    <div className="newsdesc">
                      <p
                        onClick={
                          circularData.length > 0
                            ? () => modalPopup(item)
                            : undefined
                        }
                      >
                        {" "}
                        {circularData.length > 0 ? item.title : ""}
                      </p>
                    </div>
                    {circularData.length > 0 &&
                      item.attachments &&
                      item.attachments[0] && (
                      <Link
                        to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                        target="_blank"
                      >
                        <i className="bi bi-paperclip"></i>
                      </Link>
                      )}
                  </div>
                </li>
              ))}
            </Slider>
          </ul>
        </div>
      </div>
      {openModel && selectedItem && (
        <div className="eventPopup">
          <div className="eventpopupbody">
            <div className="eventpopupcontent">
              <button onClick={handleClose} className="closebtn">
                X
              </button>
              <div className="schooleventbox">
                <div className="schooleventrightbox">
                  <h5>
                    <div
                      dangerouslySetInnerHTML={{ __html: selectedItem.title }}
                    />{" "}
                  </h5>
                  <p>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: selectedItem.description,
                      }}
                    />
                  </p>
                  {selectedItem.attachments && selectedItem.attachments[0] && (
                    <div className="attachment popupattch">
                      <Link
                        to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${selectedItem?.attachments}`}
                        target="_blank"
                      >
                        {" "}
                        Click Here To View
                      </Link>
                    </div>
                  )}
                </div>
                {selectedItem.images &&
                selectedItem.images.length > 0 &&
                selectedItem.images.length === 1
                  ? selectedItem.images.map((image, index) => (
                      <div
                        key={index}
                        className="schooleventleftbox galleryCount sub-gallerycount"
                      >
                        <LazyLoad>
                          <a
                            data-magnify="gallery"
                            data-src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${image}`} // Using image source for gallery
                            data-group="a"
                            href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${image}`}
                          >
                            <img
                              src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${image}`}
                              className="img-fluid float-start"
                              alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                            />
                          </a>
                        </LazyLoad>
                      </div>
                    ))
                  : null}
                {selectedItem.images &&
                selectedItem.images.length > 0 &&
                selectedItem.images.length > 1
                  ? selectedItem.images.map((image, index) => (
                      <div
                        key={index}
                        className="schooleventleftbox galleryCount sub-gallerycount  multi-img"
                      >
                        <LazyLoad>
                          <a
                            data-magnify="gallery"
                            data-src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${image}`} // Using image source for gallery
                            data-group="a"
                            href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${image}`}
                          >
                            <img
                              src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${image}`}
                              className="img-fluid"
                              alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                            />
                          </a>
                        </LazyLoad>
                      </div>
                    ))
                  : null}
              </div>

              <div className="row">
                {selectedItem.galleryAttachments?.length > 0 &&
                  selectedItem.galleryAttachments.map((item, index) => (
                    <div
                      key={index}
                      className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"
                    >
                      <LazyLoad>
                        <a
                          data-magnify="gallery"
                          data-src=""
                          data-group="a"
                          href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item}`}
                        >
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item}`}
                            className=" img-fluid"
                            alt="The Air Force School Subroto Park"
                          />
                        </a>
                      </LazyLoad>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default News;
